import { api } from "./api.service";
import { toast } from "sonner";

async function registerUser(
  name: string,
  email: string,  
  password: string,    
  confirmPassword:string,
  terms: boolean,
): Promise<any> {
  try {
    
    const  response  = await api.post(`/user/create`,
      {
        name: name,
        email: email,  
        password: password,    
        confirmPassword:confirmPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }

    );
    toast.success("Cadastro criado com sucesso!");
    return response.data;
    
  } catch (error: any) {
    // Exibe a mensagem de erro retornada pela API, se disponível
    const errorMessage = error?.response?.data?.message 
      || "Ops, tivemos um problema para criar o cadastro. Tente novamente.";
    
    toast.error(errorMessage);
        
    console.log("Erro no cadastro:", error?.response?.data || error.message);
    return null;
  }
}

export { registerUser };
